import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const persistPlugin = createPersistedState({
  paths: ["auth"]
});

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {},
  plugins: [persistPlugin]
});
